import { render, staticRenderFns } from "./skuAdd.vue?vue&type=template&id=0854966b&scoped=true"
import script from "./skuAdd.vue?vue&type=script&lang=js"
export * from "./skuAdd.vue?vue&type=script&lang=js"
import style0 from "./skuAdd.vue?vue&type=style&index=0&id=0854966b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0854966b",
  null
  
)

export default component.exports